<template>
  <div class="container">
    <BaseFrame  :infos='infos' :idText='idText' :able='able' logText="操作日志"
               @hanldeLog="getModifiedRecord"  :logData='LogItems'>
      <div slot="content">
        <lk-form :model="branchForm.sysStore" label-position="right" :label-width="130"
                 ref="branchForm">
          <div class="cardContainer">
            <lk-card title="基本信息">
              <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="门店名称:" prop="name">
                    <span>{{branchForm.sysStore.name |defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1'>
                  <lk-form-item label="门店简称:">
                    <span>{{branchForm.sysStore.shortName|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1'>
                  <lk-form-item label="企业负责人（备案）:">
                    <span>{{branchForm.sysStore.leaderName|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="电话:" prop='phone'>
                    <span>{{branchForm.sysStore.phone|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="门店面积:" prop='area'>
                    <span>{{branchForm.sysStore.area|defaultStr}}平方米</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="门店地址:" prop="locationArr">
                    <span>
                    {{branchForm.sysStore.provinceName+branchForm.sysStore.cityName+branchForm.sysStore.countyName|defaultStr}}
                    </span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="详细地址:">
                    <span>{{branchForm.sysStore.address|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="附近医院/输注中心:">
                    <span>{{branchForm.sysStore.hospitalAddress|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="经营方式:">
                    <span>{{bizMode[branchForm.sysStore.bizMode]|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="经度:">
                    <span>{{branchForm.sysStore.longitude|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="纬度:">
                    <span>{{branchForm.sysStore.latitude|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="营业开始时间:">
                    <span>{{branchForm.sysStore.businessStartTime|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row>
                <lk-col span="7">
                  <lk-form-item label="营业结束时间:">
                    <span>{{branchForm.sysStore.businessEndTime|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="门店级别:">
                    <span>{{levels[branchForm.sysStore.level - 1]|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1'>
                  <lk-form-item label="药店类型:" >
                    <span>{{storeTypes[branchForm.sysStore.type - 1]|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1'>
                  <lk-form-item label="是否医保店:" class="inline">
                    <span>{{judge[branchForm.sysStore.isMedicare]|defaultStr }}</span>
                  </lk-form-item>
                  <lk-form-item label="医保备注:" v-if="branchForm.sysStore.isMedicare === 1">
                    <span>{{branchForm.sysStore.medicareRemark|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>

                <!-- <lk-col span="7" >
                </lk-col> -->
                <lk-col span="23">
                  <lk-form-item label="经营类别:" class="mt8 treeFormat" prop='goodsLabelIds'>
                    <span>{{bizScopeListStr|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="23">
                  <lk-form-item label="门店管理员:" class="mt8 treeFormat" prop='managerListStr'>
                    <span>{{managerListStr|defaultStr}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="cardContainer">
            <lk-card title="资质信息">
              <lk-row :gutter="16">
                <lk-col span="7" class="backGroundCard">
                  <lk-form-item prop='bizLicenseUrl' class="mt8">
                    <div class="label required withPic">
                      <label>营业执照:</label>
                    </div>
                    <Uploader :able='able' v-model="branchForm.sysStore.bizLicenseUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="统一社会信用代码:" prop='bizLicenseCode'>
                    <span>{{branchForm.sysStore.bizLicenseCode|defaultStr}}</span>
                  </lk-form-item>
                  <lk-form-item label="有效日期:" prop='bizLicenseExpiry'>
                    <span v-if="branchForm.sysStore.bizLicenceForever">长期有效</span>
                    <expirePicker v-else :able='false' :type='1' v-model.trim="branchForm.sysStore.bizLicenseExpiry"/>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1' class="backGroundCard">
                  <lk-form-item prop='goodsLicenseUrl' class="mt8">
                    <div class="label withPic">
                      <label>药品经营许可证:</label>
                    </div>
                    <Uploader :able='able' v-model="branchForm.sysStore.goodsLicenseUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="证件号:" prop='goodsLicenseCode'>
                    <span>{{branchForm.sysStore.goodsLicenseCode|defaultStr}}</span>
                  </lk-form-item>
                  <lk-form-item label="有效日期:" prop='goodsLicenseExpiry'>
                    <expirePicker :able='false' :type='1' v-model.trim="branchForm.sysStore.goodsLicenseExpiry"/>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1' class="backGroundCard">
                  <lk-form-item prop='gspUrl' class="mt8">
                    <div class="label withPic">
                      <label>GSP规范认证证书:</label>
                    </div>
                    <Uploader :able='able' v-model="branchForm.sysStore.gspUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="证件号:" prop='gspCode'>
                    <span>{{branchForm.sysStore.gspCode|defaultStr}}</span>
                  </lk-form-item>
                  <lk-form-item label="有效日期:" prop='gspExpiry'>
                    <expirePicker :able='false' :type='1' v-model.trim="branchForm.sysStore.gspExpiry"/>
                    <!-- <span>{{branchForm.sysStore.gspExpiry| formatDate}}</span>
                    <expire-info
                      :day="180"
                      :dateTime="`${branchForm.sysStore.gspExpiry}`"
                    >
                    </expire-info>-->
                  </lk-form-item>
                </lk-col>
                </lk-row>
                <lk-row :gutter="16">
                <lk-col span="7" class="backGroundCard">
                  <lk-form-item prop='foodLicenseUrl' class="mt8">
                    <div class="label withPic">
                      <label>食品经营许可证:</label>
                    </div>
                    <Uploader :able='able' v-model="branchForm.sysStore.foodLicenseUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="证件号:" prop='foodLicenseCode'>
                    <span>{{branchForm.sysStore.foodLicenseCode|defaultStr}}</span>
                  </lk-form-item>
                  <lk-form-item label="有效日期:" prop='foodLicenseExpiry'>
                    <expirePicker :able='false' :type='1' v-model.trim="branchForm.sysStore.foodLicenseExpiry"/>
                    <!-- <span>{{branchForm.sysStore.foodLicenseExpiry | formatDate}}</span>
                    <expire-info
                      :day="180"
                      :dateTime="`${branchForm.sysStore.foodLicenseExpiry}`"
                    >
                    </expire-info> -->
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1' class="backGroundCard">
                  <lk-form-item prop='thirdMedicalUrl' class="mt8">
                    <div class="label withPic">
                      <label>第三类医疗器械经营许可证:</label>
                    </div>
                    <Uploader :able='able' v-model="branchForm.sysStore.thirdMedicalUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="证件号:" prop='thirdMedicalCode'>
                    <span>{{branchForm.sysStore.thirdMedicalCode|defaultStr}}</span>
                  </lk-form-item>
                  <lk-form-item label="有效日期:" prop='thirdMedicalExpiry'>
                    <expirePicker :able='false' :type='1' v-model.trim="branchForm.sysStore.thirdMedicalExpiry"/>
                    <!-- <span>{{branchForm.sysStore.thirdMedicalExpiry | formatDate}}</span>
                    <expire-info
                      :day="180"
                      :dateTime="`${branchForm.sysStore.thirdMedicalExpiry}`"
                    >
                    </expire-info> -->
                  </lk-form-item>
                  <!-- <lk-form-item label="社会统一信用码:">
                    <span>{{branchForm.sysStore.creditCode|defaultStr}}</span>
                  </lk-form-item> -->
                </lk-col>
                <lk-col span="7" offset='1' class="backGroundCard">
                  <lk-form-item class="mt8">
                    <div class="label withPic">
                      <label>二类医疗器械经营备案:</label>
                    </div>
                    <Uploader :able='able' v-model="branchForm.sysStore.secondMedicalUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="证件号:" prop='secondMedicalCode'>
                    <span>{{branchForm.sysStore.secondMedicalCode|defaultStr}}</span>
                  </lk-form-item>
                  <lk-form-item label="备案日期:" prop='secondMedicalDate'>
                    <span>{{branchForm.sysStore.secondMedicalDate | formatDate}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '@/components/frame/BaseFrame.vue';
import Uploader from '@/components/Uploader.vue';
import system from '@/services/system';
import utils from '@/libs/utils';
// import expireInfo from '@/components/expireInfo/expireInfo.vue';
import expirePicker from '../../components/expireInfo/expirePicker.vue';

export default {
  name: 'branchInfo',
  components: {
    BaseFrame,
    Uploader,
    expirePicker,
    // expireInfo,
  },
  data() {
    return {
      goodsLabelTree: [],
      modifiedRecords: [],
      idText: '',
      url: '',
      logShow: false,
      LogItems: [],
      judge: ['', '是', '否'],
      bizMode: ['', '零售', '生产', '批发'],
      able: false,
      infos: null,
      leaders: [],
      managers: [],
      levels: ['一级', '二级', '三级'],
      storeTypes: ['直营', '收购', '加盟'],
      bizScopeListStr: '',
      managerListStr: '',
      branchForm: {
        sysStore: {
          address: '',
          bizLicenseUrl: '',
          bizLicenseCode: '',
          bizLicenseExpiry: null,
          cityId: null,
          cityName: '',
          countyId: null,
          countyName: '',
          locationArr: [],
          creditCode: '',
          storeNo: '',
          goodsLicenseUrl: '',
          goodsLicenseCode: '',
          goodsLicenseExpiry: null,
          foodLicenseUrl: '',
          foodLicenseCode: '',
          foodLicenseExpiry: null,
          gspUrl: '',
          gspCode: '',
          gspExpiry: null,
          id: '',
          hospitalAddress: '',
          isMedicare: '',
          medicareRemark: '',
          leader: null,
          leaderName: '',
          manager: '',
          managerName: '',
          name: '',
          shortName: '',
          bizMode: null,
          operationScope: [],
          level: null,
          type: '',
          provinceId: null,
          provinceName: '',
          secondMedicalUrl: '',
          secondMedicalCode: '',
          status: null,
          phone: '',
          area: '',
          thirdMedicalUrl: '',
          thirdMedicalCode: '',
          thirdMedicalExpiry: null,
        },
      },
    };
  },
  methods: {
    getModifiedRecord() {
      system.getStoreHistory({ id: this.branchForm.sysStore.id }).then((res) => {
        if (res.data.status === 200) {
          this.LogItems = utils.deepClone(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getInfo(id) {
      return new Promise((resolve) => {
        system.storeInfo({ id }).then((res) => {
          if (res.data.status === 200) {
            const temp = Object.assign({}, res.data.data);
            const modifiedRecord = {};
            this.idText = '门店ID';
            modifiedRecord.id = temp.sysStore.id;
            modifiedRecord.createUserName = temp.sysStore.createUserName;
            modifiedRecord.createTime = utils.formatTime(temp.sysStore.createTime);
            modifiedRecord.modifiedUserName = temp.sysStore.modifiedUserName;
            modifiedRecord.modifiedTime = utils.formatTime(temp.sysStore.modifiedTime);
            this.infos = modifiedRecord;
            temp.sysStore.area = temp.sysStore.area ? utils.exchangePercent(temp.sysStore.area) : '';
            this.bizScopeListStr = temp.bizScopeList.map(scopeItem => scopeItem.name).join(',');
            this.managerListStr = temp.managerList.map(scopeItem => scopeItem.name).join(',');
            this.branchForm = Object.assign({}, temp);
            const roleNames = [];
            this.$store.state.user.roles.forEach((item) => {
              roleNames.push(item.name);
            });
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    showLogInfo() {
      this.logShow = true;
    },
  },
  mounted() {
    this.getInfo(this.$route.params.id);
  },
};
</script>
<style lang="less" scoped>
  .cardContainer {
    margin-bottom: 16px;
  }
  .p-font{
    padding: 0 10px;
    margin-bottom: 10px;
  }
  .backGroundCard{
    background: linear-gradient(180deg, #f5f5f5 0, #f5f5f5 calc(~'100% - 8px'),#fff calc(~'100% - 7px'));
    padding-top: 4px;
    padding-bottom: 4px;
  }
</style>
